import COMPANY_HIERARCHY_TYPES from '@aretheyhappy/lib-taxonomy/company/hierarchy_types';
import ADDITIONAL_HIERARCHY_TYPES from '@aretheyhappy/lib-taxonomy/company/additional_hierarchy_types';
const CHIERARCHY = Object.assign({}, COMPANY_HIERARCHY_TYPES, { LABEL: 'ch:label' });
export { CHIERARCHY };
const CHIERARCHY_ICONS = {
    // Primary Hierarchy
    [CHIERARCHY.LABEL]: 'label',
    [CHIERARCHY.GROUP]: 'folder',
    [CHIERARCHY.BRAND]: 'folder',
    [CHIERARCHY.LOCATION]: 'store',
    [CHIERARCHY.COMPANY]: 'apartment',
    // Secondary Hierarchy
    [ADDITIONAL_HIERARCHY_TYPES.GROUP]: 'folder',
    [ADDITIONAL_HIERARCHY_TYPES.ROOT]: 'apartment',
    [ADDITIONAL_HIERARCHY_TYPES.LEAF]: 'store',
};
export { CHIERARCHY_ICONS };
//# sourceMappingURL=hierarchy_icons.js.map